import { html, rune, type Html, View, $ as $E, $ } from 'rune-ts';
import Swiper from 'swiper';
import { EffectFade, Navigation } from 'swiper/modules';
import klass from './MarketingSection.module.scss';
import { font, staticFont } from '@services/MarppleShop/shared/typography';
import { isFixedElementInSection } from '@services/MarppleShop/shared/util/elementPositionHelper.ts';
import { linkArrowIcon } from '@services/MarppleShop/shared/components/atoms/Icon/foundation_icons.ts';

export class MarketingSection extends View<{ is_mobile: boolean }> {
  currentIndex = 'marketing';
  swiper?: Swiper;
  current_index = 1;
  max_index = 3;

  override template(): Html {
    const { is_mobile } = this.data;
    const texts = {
      title: html` 마플샵에선 크리에이터를 위해<br />다양한 홍보를 지원해줘요`,
      marketing: html`마플샵을 통해 100만 명 이상의<br />
        사람들에게 소개돼요`,
      popup: html`팝업의 성지 성수동에서<br />오프라인 팝업스토어를 열어줘요`,
      gacha: html`오프라인 팝업스토어에<br />나만의 가챠머신을 만들어줘요`,
      ad: html`선주문과 펀딩을 더한 <span class="${klass.mo_br}">프리오더 챌린지와 함께<br /></span> 팬들에게
        다양한 혜택을 제공해 줘요`,
      partner: html`기획부터 운영까지 도와드리는<br />마플샵 전담 매니저님이 생겨요`,
    };

    return is_mobile
      ? html`
          <section class="${klass.container}">
            <div class="${klass.title_wrapper}">
              <div class="${staticFont('bebas_20_bold')}">CHAPTER 4.</div>
              <div class="${font('14_medium')}">${texts.title}</div>
            </div>
            <div class="${klass.content_wrapper}">
              <div class="${klass.content} swiper_marketing" data-id="marketing">
                <div class="${font('20_bold')}">${texts.marketing}</div>
                <div class="${klass.swiper_wrapper} swiper-wrapper">
                  <div class="${klass.marketing_image_wrapper} swiper-slide">
                    <div class="${font('16_bold')}">
                      마플샵 홈 배너 노출 지원<br />
                      월 130만 명 이상 방문
                    </div>
                    <img
                      src="//s3.marpple.co/files/u_29089/2025/11/original/2ea47dee8230a901b3b040c7e299229cb5a739cd2.png"
                      class="${klass.marketing_image}"
                      alt="서비스 종류 이미지"
                    />
                  </div>
                  <div class="${klass.marketing_image_wrapper} swiper-slide">
                    <div class="${font('16_bold')}">마플샵 공식 인스타그램 : 23K 팔로워</div>
                    <img
                      src="//s3.marpple.co/files/u_29089/2025/11/original/7dba5fed5e1129344e02e8f1e375a5e266181cca1.webp"
                      class="${klass.marketing_image}"
                      alt="서비스 종류 이미지"
                    />
                  </div>
                  <div class="${klass.marketing_image_wrapper} swiper-slide">
                    <div class="${font('16_bold')}">마플샵 공식 X : 8K 팔로워</div>
                    <img
                      src="//s3.marpple.co/files/u_29089/2025/11/original/0754cd72366897747f0248f3d882f80c1fb272be2.webp"
                      class="${klass.marketing_image}"
                      alt="서비스 종류 이미지"
                    />
                  </div>
                </div>
                <div class="pagination ${klass.pagination} ${staticFont('bebas_14_bold')}">
                  <span class="current_index"> 0${this.current_index} </span>
                  <div class="${klass.pages}">
                    <div class="progress ${klass.page}" style="width: ${this.calcProgress()}%;"></div>
                  </div>
                  <span> 0${this.max_index} </span>
                </div>
              </div>
              <div class="${klass.content}" data-id="popup">
                <div class="${font('20_bold')}">${texts.popup}</div>
                <div class="${klass.popup_image_wrapper}">
                  <img
                    src="//s3.marpple.co/files/u_29089/2025/11/original/49fac6ccc58d4a0704155db8cd3e04d469e25f533.webp"
                    class="${klass.popup_image}"
                    alt="서비스 종류 이미지"
                  />
                  <a
                    href="https://marppleshopoffline.oopy.io/"
                    target="_blank"
                    class="${font('16_bold')} ${klass.popup_button}"
                  >
                    마플샵 팝업스토어 더보기 ${linkArrowIcon({ klass: klass.icon })}
                  </a>
                </div>
              </div>
              <div class="${klass.content}" data-id="gacha">
                <div class="${font('20_bold')}">${texts.gacha}</div>
                <img
                  src="//s3.marpple.co/files/u_29089/2025/11/original/2d1dcfe8e094fb649ac1236bc768a27e328c75be4.webp"
                  class="${klass.full_image}"
                  alt="서비스 종류 이미지"
                />
              </div>
              <div class="${klass.content}" data-id="ad">
                <div class="${font('20_bold')}">${texts.ad}</div>
                <img
                  src="//s3.marpple.co/files/u_29089/2025/11/original/948310d33dee867d94810dea6023f4cb4ec5b53e5.webp"
                  class="${klass.full_image}"
                  alt="서비스 종류 이미지"
                />
              </div>
              <div class="${klass.content}" data-id="partner">
                <div class="${font('20_bold')}">${texts.partner}</div>
                <div class="${klass.popup_image_wrapper}">
                  <img
                    src="//s3.marpple.co/files/u_29089/2025/11/original/1ff5fdecba628737de2b8c7b5a81168d9fa41e356.webp"
                    class="${klass.popup_image}"
                    alt="서비스 종류 이미지"
                  />
                </div>
              </div>
            </div>
          </section>
        `
      : html`
          <section class="${klass.container}">
            <div class="${klass.index_wrapper}">
              <div class="${klass.index}">
                <div class="${klass.title}">
                  <div class="${staticFont('bebas_20_bold')}">CHAPTER 4.</div>
                  <div class="${font('20_medium')}">${texts.title}</div>
                </div>
                <ul class="${staticFont('bebas_96_bold')} ${klass.index_list}">
                  <li class="${klass.active}" data-id="marketing">MARKETING</li>
                  <li data-id="popup">POPUP STORE</li>
                  <li data-id="gacha">GACHA PRODUCTS</li>
                  <li data-id="ad">PRE-ORDER CHALLENGE</li>
                  <li data-id="partner">PARTNER</li>
                </ul>
              </div>
            </div>
            <div class="${klass.content_wrapper}">
              <div class="${klass.pointer}">pointer</div>
              <div class="${klass.content}" data-id="marketing">
                <div class="${font('32_bold')}">${texts.marketing}</div>
                <div class="${klass.marketing_image_wrapper}">
                  <div class="${klass.banner_image_wrapper}">
                    <div class="${font('16_bold')} ${klass.banner_text}">
                      마플샵 홈 배너 노출 지원 : 월 130만 명 이상 방문
                    </div>
                    <img
                      src="//s3.marpple.co/files/u_29089/2025/11/original/2ea47dee8230a901b3b040c7e299229cb5a739cd2.png"
                      class="${klass.banner_image}"
                      alt="서비스 종류 이미지"
                    />
                  </div>
                  <div class="${klass.post_image_container}">
                    <div class="${klass.post_image_wrapper}">
                      <div class="${font('16_bold')} ${klass.post_text}">
                        마플샵 공식 인스타그램 : 23K 팔로워
                      </div>
                      <img
                        src="//s3.marpple.co/files/u_29089/2025/11/original/7dba5fed5e1129344e02e8f1e375a5e266181cca1.webp"
                        class="${klass.post_image}"
                        alt="서비스 종류 이미지"
                      />
                    </div>
                    <div class="${klass.post_image_wrapper}">
                      <div class="${font('16_bold')} ${klass.post_text}">마플샵 공식 X : 8K 팔로워</div>
                      <img
                        src="//s3.marpple.co/files/u_29089/2025/11/original/0754cd72366897747f0248f3d882f80c1fb272be2.webp"
                        class="${klass.post_image}"
                        alt="서비스 종류 이미지"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="${klass.content}" data-id="popup">
                <div class="${font('32_bold')}">${texts.popup}</div>
                <div class="${klass.popup_image_wrapper}">
                  <img
                    src="//s3.marpple.co/files/u_29089/2025/11/original/49fac6ccc58d4a0704155db8cd3e04d469e25f533.webp"
                    class="${klass.popup_image}"
                    alt="서비스 종류 이미지"
                  />
                  <a
                    href="https://marppleshopoffline.oopy.io/"
                    target="_blank"
                    class="${font('16_bold')} ${klass.popup_button}"
                  >
                    마플샵 팝업스토어 더보기 ${linkArrowIcon({ klass: klass.icon })}
                  </a>
                </div>
              </div>
              <div class="${klass.content}" data-id="gacha">
                <div class="${font('32_bold')}">${texts.gacha}</div>
                <img
                  src="//s3.marpple.co/files/u_29089/2025/11/original/2d1dcfe8e094fb649ac1236bc768a27e328c75be4.webp"
                  class="${klass.full_image}"
                  alt="서비스 종류 이미지"
                />
              </div>
              <div class="${klass.content}" data-id="ad">
                <div class="${font('32_bold')}">${texts.ad}</div>
                <img
                  src="//s3.marpple.co/files/u_29089/2025/11/original/948310d33dee867d94810dea6023f4cb4ec5b53e5.webp"
                  class="${klass.full_image}"
                  alt="서비스 종류 이미지"
                />
              </div>
              <div class="${klass.content}" data-id="partner">
                <div class="${font('32_bold')}">${texts.partner}</div>
                <div class="${klass.popup_image_wrapper}">
                  <img
                    src="//s3.marpple.co/files/u_29089/2025/11/original/1ff5fdecba628737de2b8c7b5a81168d9fa41e356.webp"
                    class="${klass.popup_image}"
                    alt="서비스 종류 이미지"
                  />
                </div>
              </div>
            </div>
          </section>
        `;
  }

  handleScrollChangeIndexColor() {
    const pointer = $E(this.element()).find(`.${klass.pointer}`);

    if (pointer) {
      const $current_content = $E(this.element())
        .findAll(`.${klass.content}`)
        .find(($el) => isFixedElementInSection(pointer.element(), $el.element()));

      if (!$current_content) return;

      const index_name = $current_content.element()?.dataset.id;

      if (index_name && this.currentIndex !== index_name) {
        this.currentIndex = index_name;
        this.changeIndexColor(index_name);
      }
    }
  }

  changeIndexColor(index_name: string) {
    const $index = $E(this.element())
      .findAll(`.${klass.index_list} > li`)
      .map(($el) => {
        if ($el.element().dataset.id !== index_name) $el.removeClass(klass.active);
        return $el;
      })
      .find(($el) => $el.element().dataset.id === index_name);

    if ($index) {
      $index.addClass(klass.active);
    }
  }

  override onRender() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    if (!is_mobile) {
      this.handleScrollChangeIndexColor();

      document.addEventListener('scroll', () => this.handleScrollChangeIndexColor(), {
        passive: true,
      });

      if (window.visualViewport) {
        window.visualViewport.onresize = () => this.handleScrollChangeIndexColor();
      }
    } else {
      this.swiper = this._onLoadSwiper();
    }
  }

  private _onLoadSwiper() {
    return new Swiper('.swiper_marketing', this._createSwiperOption());
  }

  private _createSwiperOption() {
    return {
      modules: [Navigation, EffectFade],
      loop: true,
      spaceBetween: 24,
      on: {
        slideChange: (swiper: Swiper) => {
          this.setCurrentIndex(swiper.realIndex + 1);
          this.redraw();
        },
      },
    };
  }

  calcProgress() {
    return ((this.current_index + 1) / (this.max_index + 1)) * 100;
  }

  setCurrentIndex(index: number) {
    this.current_index = index;
  }

  override redraw(): this {
    $(this.element()).find('.current_index')?.setInnerHtml(`0${this.current_index.toString()}`);
    const progress = $(this.element()).find('.progress')?.element();
    if (progress) progress.style.width = `${this.calcProgress()}%`;

    return this;
  }
}
